import { useCountdown } from '../../../../utils/countdown';
import React, { useEffect } from 'react';
import { Button, Modal } from 'antd';
import { FieldTimeOutlined } from '@ant-design/icons';

function PaymentCountdownTimer({
  paymentExpiryTime,
  onClickCountdownEndedBack = () => {},
  countdownMessage = 'Your booking is now reserved. Please checkout within the time limit.',
  expiryMessage = 'Your reserved slots have expired, please try again.',
  backMessage = 'Back to booking page',
}) {
  let durationInSeconds = paymentExpiryTime
    ? Math.max((new Date(paymentExpiryTime) - Date.now()) / 1000, 0)
    : 15 * 60;
  const [, hours, minutes, seconds] = useCountdown(durationInSeconds);

  const remainingTime = hours * 3600 + minutes * 60 + seconds;
  const timeElapsed = remainingTime <= 0;

  const formatComponent = (val) => val.toString().padStart(2, '0');

  // Prevent background app scroll when time elapsed modal is open
  useEffect(() => {
    if (!document) {
      return;
    }
    if (timeElapsed) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => document && (document.body.style.overflow = 'unset');
  }, [timeElapsed]);

  const timeElapsedModal = (
    <Modal
      title={null}
      footer={null}
      closable={false}
      maskClosable={false}
      centered
      open={timeElapsed}
      width={'min(25rem, 95%)'}
      zIndex={1005}
    >
      <p className={'fs-20 gRegular mg-bottom-10 txt-center'}>
        {expiryMessage}
      </p>
      <Button
        className={
          'bg-grey gRegular br10 fs-20 white txt-center w-full pd-left-50 pd-right-50 pd-10 mg-top-10 h-fit antd-link-button-override'
        }
        style={{ whiteSpace: 'normal' }}
        onClick={onClickCountdownEndedBack}
      >
        &lt; {backMessage}
      </Button>
    </Modal>
  );

  if (hours > 12) {
    return null;
  }

  return (
    <>
      {timeElapsedModal}
      <div
        className={
          'payment_timer white sb-blue-bg gSemiBold fs-19 w-fit pd-10 pd-left-25 pd-right-25 brFull txt-center'
        }
      >
        <FieldTimeOutlined className={'fs-22'} />
        <span className={'mg-top-1'}>
          {`${hours > 0 ? `${formatComponent(hours)}:` : ''}${formatComponent(minutes)}:${formatComponent(seconds)}`}
        </span>
      </div>
      <p className={'gRegular mg-top-10 fs-16'}>{countdownMessage}</p>
    </>
  );
}

export default PaymentCountdownTimer;
